"use strict";

const SELECTORS = {
  collectionActions: "#CollectionActions",
  countValue: ".cloud-search-filter-value__count",
  facetsWrap: ".facets-wrap",
  menuLevel1: ".menu-level-1",
  sidebar: ".page-layout-sidebar",
  sidebarOpenButton: ".button-sidebar-drawer-open",
  sidebarToggle: ".xcloud-sidebar-toggle",
  sortWrapper: "#CollectionActions .collection-actions-main",
  toggleBar: "#FacetsFilterForm + .page-layout-actions-wrap",
};

// Empêcher le clic sur les liens de niveau 1 du menu principal
document.addEventListener("click", function (e) {
  const link = e.target.closest(SELECTORS.menuLevel1);
  if (link) {
    e.preventDefault();
  }
});

// Supprimer les parenthèses autour des nombres de résultats dans les filtres de recherche
const observerCount = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType === Node.ELEMENT_NODE) {
        updateCounts(node);
      }
    }
  }
});

function updateCounts(root = document) {
  const cleanCountText = (el) => {
    const cleaned = el.textContent.replace(/[()]/g, "");
    if (el.textContent !== cleaned) {
      el.textContent = cleaned;
    }
  };

  if (root.matches?.(SELECTORS.countValue)) {
    cleanCountText(root);
  }

  root
    .querySelectorAll?.(SELECTORS.countValue)
    .forEach((el) => cleanCountText(el));
}

function observeCounts() {
  const target =
    document.querySelector(SELECTORS.sidebar) ||
    document.querySelector(SELECTORS.facetsWrap);

  if (!target) return false;

  observerCount.disconnect();

  observerCount.observe(target, {
    childList: true,
    subtree: true,
  });

  return true;
}

document.addEventListener("DOMContentLoaded", () => {
  updateCounts();

  if (!observeCounts()) {
    let attempts = 0;
    const MAX_ATTEMPTS = 20;

    const retry = () => {
      attempts += 1;

      if (observeCounts() || attempts >= MAX_ATTEMPTS) {
        return;
      }

      requestAnimationFrame(retry);
    };

    requestAnimationFrame(retry);
  }
});

window.addEventListener(
  "pagehide",
  () => {
    observerCount.disconnect();
  },
  { once: true },
);

// Comportement de la sidebar sur les pages de résultat de recherche XCloud
const IS_XCLOUD_SEARCH_PAGE = location.pathname.includes("/a/search/");
if (IS_XCLOUD_SEARCH_PAGE) {
  const facets = document.querySelector(SELECTORS.facetsWrap);
  if (facets) {
    facets.classList.add("page-layout-with-sidebar");
  }

  function init() {
    injectSidebarToggle();
    ensureLayout();
  }

  function injectSidebarToggle() {
    const actions = document.querySelector(SELECTORS.collectionActions);
    const actionsParent = actions?.closest(".page-layout-main-content");

    if (!actions || !actionsParent) return;

    if (
      !document.querySelector(SELECTORS.sidebarToggle) &&
      window.maranelloFiltersButton
    ) {
      actionsParent.insertAdjacentHTML(
        "beforebegin",
        window.maranelloFiltersButton,
      );
    }

    const toggleBar = document.querySelector(SELECTORS.toggleBar);

    if (toggleBar) {
      toggleBar.classList.remove("page-layout-fullwidth");
      toggleBar.classList.add("page-layout-with-sidebar");
    }
  }

  function ensureLayout() {
    const facets = document.querySelector(SELECTORS.facetsWrap);

    if (!facets) return null;
    facets.classList.remove("page-layout-fullwidth");
    facets.classList.add(
      "page-layout-with-sidebar",
      "page-layout-with-sidebar-drawer",
    );
  }

  function start() {
    init();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }

  const sortWrapper = document.querySelector(SELECTORS.sortWrapper);
  if (
    sortWrapper &&
    window.filterButtonMobile &&
    !sortWrapper.querySelector(SELECTORS.sidebarOpenButton)
  ) {
    sortWrapper.insertAdjacentHTML("afterbegin", window.filterButtonMobile);
  }

  const BODY_OPEN_CLASSES = [
    "page-layout-sidebar-drawer-open",
    "overflow-hidden-tablet",
  ];

  function setSidebarState(open) {
    document.body.classList.toggle(BODY_OPEN_CLASSES[0], open);
    document.body.classList.toggle(BODY_OPEN_CLASSES[1], open);
  }

  function isSidebarOpen() {
    return document.body.classList.contains("page-layout-sidebar-drawer-open");
  }

  document.body.addEventListener("click", (event) => {
    const isOpenTrigger = event.target.closest(SELECTORS.sidebarOpenButton);
    const isInsideSidebar = event.target.closest(SELECTORS.sidebar);

    if (isOpenTrigger) {
      setSidebarState(true);
      return;
    }

    if (isSidebarOpen() && !isInsideSidebar) {
      setSidebarState(false);
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && isSidebarOpen()) {
      setSidebarState(false);
    }
  });
}
